var _polygon, _path, _path2, _polygon2, _path3, _path4, _path5, _polygon3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _polyline, _polyline2, _path15, _path16, _path17, _polygon4, _polygon5, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _ellipse, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "167.3 112.49 168.21 116.36 216.81 116.36 226.02 108.39 197.34 103.38 167.3 112.49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M348.53,415.37,237.42,434.8l-38.14-16,87-8.78,8.07-3a11,11,0,0,1,18.2-6.66l20-7.31H346m-183.1,10.47-11.09-4.65a35.81,35.81,0,0,0,3-4.41h0l.19-.35h0l.11-.2,7.81,9.61Zm69.4-287.22,9.2-8.86,70,8.86ZM439.74,304.5l-1,52.57-9.66,6.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M184.83,116.36l-3-.17-.15.17ZM154.41,393.11l22.7,27.95,109.22-11,8.07-3a11,11,0,0,1,18.2-6.66l20-7.31Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "170.18 435.15 199.18 421.61 220.4 434.46 170.18 435.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M127.22,393.11l.39.16c.92,1.25,2,2.9,3.35,5,3.64,5.54,7.47,9.26,13.3,7a15.47,15.47,0,0,0,4.56-3.05l7,2.93-35.05,8-7.41-18.3c.4-.2.8-.41,1.21-.64l2-1.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M131,398.28c3.64,5.54,7.47,9.26,13.3,7,3.91-1.55,8.38-6.44,11.3-12.12H127.49c.94,1.26,2,3,3.47,5.17Zm-73.5-98.41a7.83,7.83,0,0,0-5.81-3.56c-9.37-.85-16.4,14.42-18.58,2.65s-9-22-17.77-16.34-16.95,19.56-4.47,27.72-.77,20.43,6.72,29.84,22.88-3.09,28.91,5.73c4.64,6.78,5.12,19.14,11,23.89V299.87ZM93.1,393.11c4.34,5.77,11.2,6.7,21.45,1.1l2-1.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M154.8,394.52c.26-.46.51-.93.76-1.41H152l2.82,1.41ZM57.46,299.87a7.83,7.83,0,0,0-5.81-3.56c-9.37-.85-16.4,14.42-18.58,2.65s-9-22-17.77-16.34a26.64,26.64,0,0,0-7.85,7.9c13,11.56,32.44,28.66,50,43.47Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "420.37 148.44 431.08 153.42 423.9 163.52 420.37 158.63 420.37 148.44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M440.05,185.34c9-2,20.18,3.88,16.42-6.07-4.36-11.52-3.12-24.15,9-23.92s28.24,8.09,20.07,22,12.21,17.56,9.83,29.86-25.08,9.58-26.3,20.59,10,26.53-4,32.37-28,3.21-23.65,11.21c9.28,17.14,9.88,29.61-4.35,33.93-.4.12-.81.23-1.24.34m-15.42-51.88V241.08M429.06,222a9.61,9.61,0,0,0,3.61-5.17c1.54-4.48.83-9.37.1-14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M440.27,185.29c8.94-1.8,19.93,3.85,16.2-6-4.36-11.52-3.12-24.15,9-23.92a33,33,0,0,1,12.42,2.72c-8.63,21.75-22.8,56.86-34.24,82.26a252.21,252.21,0,0,1-14.47,27.23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M57.46,193.58c-1.08-.88-1.26-2.52,0-5.63V162.11a9.75,9.75,0,0,0-5.53-2.06c-11.35-.9-27.28,6.3-21.2,22.49s-13.36,18.33-12.5,32.2,22.35,13,22.27,25.36-12.34,28.5.17,36.31c6.17,3.86,12.53,5.43,16.79,7V193.58Zm0,105.14c-5.73,12.14-6.5,21.76,0,27.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M57.46,193.59c-1.08-.88-1.26-2.53,0-5.64V162.11a9.75,9.75,0,0,0-5.53-2.06A27,27,0,0,0,40,161.9c4.39,19.43,11,48.17,17.44,73.76Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M346,393.11H65.37a7.94,7.94,0,0,1-7.91-7.92V124.28a7.94,7.94,0,0,1,7.91-7.92H125c0,.35,0,.71,0,1.07a16.87,16.87,0,0,0,33.73,0c0-.36,0-.72,0-1.07H412.47a7.93,7.93,0,0,1,7.9,7.92V162"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M341.24,370.64h-260a8,8,0,0,1-8-8V146.8a8,8,0,0,1,8-8H396.64a8,8,0,0,1,7.95,8v10.41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M361.62,181.39c-6.51.55-11.38,2.55-14.87,5.5-14.08,11.91-6.63,40.94,4.37,50.31,7.5,6.38,20.46,7.94,29.44,3.46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M361.34,182.18c-9.14,9.6-4.29,53.26,16.93,57.26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M293.23,292.17l-4.28-.45c-2,.56-4.37,1.36-5.3.54a.93.93,0,0,1-.24-1.11l-7.51-.77c-.69,0-.94,1.32-.29,1.66L287,294.32a1.73,1.73,0,0,1,1-.46c1-.18,1.6.43,2.23,1.1l2.63.53C294.07,295.35,294.27,292.75,293.23,292.17Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M312.07,296a5.74,5.74,0,0,1-1.66-1c-2-1.79-9.3-9.69-12.34-9.95s-8.55,2.2-10.78,3.15-4.91,2.94-3.64,4.07c.94.83,3.37,0,5.34-.55,2.38-.66,5.86-.87,7.43,1.4.75,1.09-1.91,3.81-4,3.32s-2.4-2.91-4.35-2.57-1.17,1.7-.48,3.26-.1,3.76,1.59,4.17,4.57,2.5,6.1,1.86a22.74,22.74,0,0,1,7.22-1,25.94,25.94,0,0,1,5.47,1.69A17,17,0,0,1,312.07,296Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M387.18,247.88a88.73,88.73,0,0,0-11.13,1,38.75,38.75,0,0,0-8.13,2.13l-1,.42v-.07a11.5,11.5,0,0,0-4,2.65,7.54,7.54,0,0,0-2.27,4.39,40.27,40.27,0,0,1-.65,4.55c-.34,1.74-.79,3.67-1.34,5.73l-.07.17a59.13,59.13,0,0,0-2.59,5.71l-1.74.34.05-.12a69.14,69.14,0,0,1,2.91-6.58c.53-2,1-3.86,1.29-5.54a39.2,39.2,0,0,0,.63-4.37,9.08,9.08,0,0,1,2.7-5.34,13.08,13.08,0,0,1,5.62-3.36,40.7,40.7,0,0,1,8.43-2.2,89.66,89.66,0,0,1,11.32-1.07l.05,1.52Zm-41.65,50.75c-.55.66-1.17,1.33-1.77,1.93a11.06,11.06,0,0,1-2.3,1.83l-.28.09c-7.11.68-19.47-4.12-26.76-7l-.6-.23a16.46,16.46,0,0,0-5.46,10.59c5.13,2.3,7.81,3.45,10.49,4.59s5.58,2.38,11,4.83a42,42,0,0,0,12.27,3.25,22.4,22.4,0,0,0,10-.95l.68-.26.36.92v.13c-.12,1.07-.25,2.17-.43,3.27a32,32,0,0,1-.66,3.19c-2.32,8.52-5,18.94-7.1,29.86a195.22,195.22,0,0,0-3.88,32.4c1.84.56,8.24,2.2,14.64.42,7.47-2.08,13.73-15.47,13.75-15.51l1.42.17s3.4,16.3,7.48,17.37a67.69,67.69,0,0,0,27.85,1.12A68.45,68.45,0,0,0,432,381c-.77-4.28-6.58-35.77-13.33-49.74l1.37-.66c7.33,15.19,13.52,50.53,13.54,50.64l.09.49-.42.27a69.89,69.89,0,0,1-26.76,10.18A69.14,69.14,0,0,1,378,391c-3.95-1-7-11.89-8.11-16.48-2.1,3.9-7.45,12.69-13.76,14.44-8,2.24-16-.59-16-.6l-.53-.18v-.55a197.39,197.39,0,0,1,3.92-33.23c2.14-11,4.8-21.43,7.12-30a28.48,28.48,0,0,0,.64-3c.1-.66.19-1.34.28-2a25.27,25.27,0,0,1-9.55.66,43.81,43.81,0,0,1-12.75-3.38c-5.45-2.45-8.21-3.63-11-4.81s-5.58-2.39-11-4.84l-.49-.22.05-.54a18,18,0,0,1,6.36-12.42l.35-.3,1.46.56c7.11,2.76,19.13,7.43,25.91,6.86a10.91,10.91,0,0,0,1.82-1.5,29.92,29.92,0,0,0,2.21-2.46l.62,1.61Zm79.85-39.09a10.44,10.44,0,0,0-2.54-3.63c-1.8-1.72-6.91-4.08-9.28-4.95a53.84,53.84,0,0,0-5.92-1.75c-.62-.15-1.32-.29-2.07-.41s-1.58-.25-2.48-.36l.18-1.5c.89.11,1.75.23,2.55.36s1.52.28,2.17.44a51.35,51.35,0,0,1,6.09,1.8c2.84,1,7.86,3.16,10,5.2a10.18,10.18,0,0,1,2.78,4.48Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "345.31 388.7 350.33 432.87 419.26 430.65 426.59 385.03"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "345.3 388.57 350.33 432.87 419.2 430.81 426.57 384.89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M380.34,270.11a34.23,34.23,0,0,1,11-9.69c-2,.07-3.25.11-8.07.14l-3.51-2.3-.55.3a35.69,35.69,0,0,0-3.52,10.87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M364.72,327.61l2.54-.67v0c1-.31,1.74-.44,2.75-.74a.27.27,0,0,1,.12,0l21.63-6.95-11.22-48.94-2,.82L352,281.77l-6.1,2.46-1.3.54-13.84-27.09-1,.4L355,322.83c2.51-.58,5.71.43,9,4C364.26,327.15,364.5,327.4,364.72,327.61Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M364.72,327.61l2.54-.67v0c1-.31,1.74-.44,2.75-.74a.27.27,0,0,1,.12,0l8.48-2.26c0-.18.1-.37.16-.54a132.48,132.48,0,0,0,13-4.15l-11.22-48.94-2,.82L352,281.77l-6.1,2.46-1.3.54-.25-.49,0,.63,10.79,37.88c2.49-.5,5.62.54,8.88,4.07C364.26,327.15,364.5,327.4,364.72,327.61Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "379.9 268.73 380.53 270.29 344.31 284.6 331.25 258.64 333.02 257.86 346.25 278.09 379.9 268.73"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "379.9 268.73 380.53 270.29 344.55 284.77 331.25 258.64 333.02 257.86 345.3 280.46 376.42 269.98 379.9 268.73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M372.19,328.09c-1.44-2-2.19-1.92-2.19-1.92-1,.3-1.74.43-2.75.74.11.56.06,1.5-.51,1.74s-1.23-.16-2.75-1.79c-5.64-6.11-10.91-4.75-13.08-.88a5.1,5.1,0,0,0-.35,4c2,6.94,13.84,10.26,18.7,5.7.88-.83,6-1.34,10.78-1.65a14.47,14.47,0,0,1-1.77-8.11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M404.66,276.09c3.17,10.11,11.6,27.46,15.38,33.87-14.55,2.92-27.33,9.88-41.28,13.42a11,11,0,0,0-.49,2.53,13.68,13.68,0,0,0,3.42,10.33c5.46,0,41.16-5.43,49-8.33,6.69-2.47,6.93-8,6.14-14-1.91-14.55-4.85-49-13.2-58.4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M438.48,191.62h0c-1.34,4.21-3.27,8.73-7.08,12.37a30.92,30.92,0,0,0,2.09-11.38c-5.54.92-11.31,1.53-16.8,2.08-17.56,1.76-29.56-2.05-29.56-2.05s1.17,7.9-2.05,12-1,7.22-1.76,8.49-1.59-8.1-6.73-7.9-5.6,8.33-4.14,12,6.05,5.42,8.24,5.42.55,15.52-2.4,16.8c-16.79-5.63-23.07-40.18-17-57.29,4.58-13,14.09-20.74,25.64-23.53,17.33-4.19,30.25.65,34.79,4.31s2,9.66,2,9.66,10.4-3.66,14.49,2.49c2.87,4.3,1.87,10.69,1,14.13h0C438.82,190.69,438.48,191.62,438.48,191.62Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M414.76,220.93a.77.77,0,0,1-1.06.27.78.78,0,0,1-.27-1.07,4.41,4.41,0,0,1,3.53-2.34,4,4,0,0,1,1.76.28,3.79,3.79,0,0,1,1.4,1,2.81,2.81,0,0,1,.65,2.74.78.78,0,1,1-1.49-.45,1.29,1.29,0,0,0-.32-1.25,2.23,2.23,0,0,0-.82-.57,2.43,2.43,0,0,0-1.08-.17A2.92,2.92,0,0,0,414.76,220.93Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M383.39,260.84l8.1-.43,1.72,8.65,7.27-10.51,17.22-6.62-6-2.39-.7.27c-5,3.37-13.61,7.12-20.92,9.23C388.57,259.49,384.39,260.19,383.39,260.84Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M386.23,247.19l-5.56.36-.85,5.92-5.51,7.68,5.45-2.89,3.51,2.3c-1.95-5,.76-10.89,3-13.37Zm-3,13.37.08.06,0-.07Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M386.26,247.16l1.21,0a15,15,0,0,0,.47-4,39.17,39.17,0,0,1-9.67-3.69c3-1.29,4.6-16.8,2.4-16.8s-6.78-1.76-8.24-5.42-1-11.8,4.14-12,6,9.16,6.73,7.9-1.46-4.39,1.76-8.49,2.05-12,2.05-12,12,3.81,29.56,2.05c8.19-.82,13.48-1.54,16.8-2.08a33.43,33.43,0,0,1-3,13.62c-1.46,3.51-3.21,9.12-2.18,14,1.66,7.82,1.87,15.64-10.28,21.78-4.21,2.13-9.44,3-14.79,3,0,.43-.05.87-.08,1.3l-.1,1.32a46.57,46.57,0,0,1,4.74.79c1.26.3,2.5.63,3.7,1-6.49,4.6-20.27,10-28.25,11.09C381.31,255.56,384.06,249.61,386.26,247.16Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M92,155.28H259.61a5.16,5.16,0,0,1,5.14,5.15v32.78a5.16,5.16,0,0,1-5.14,5.16H92a5.16,5.16,0,0,1-5.14-5.16V160.43A5.16,5.16,0,0,1,92,155.28Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M90.28,278.45a1.34,1.34,0,0,1,0-2.68h94.07a1.34,1.34,0,0,1,0,2.68Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M200.8,278.24a1.34,1.34,0,0,1,0-2.68h41.42a1.34,1.34,0,1,1,0,2.68Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M90.28,262a1.34,1.34,0,0,1,0-2.67H261.36a1.34,1.34,0,0,1,0,2.67Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M90.28,245.18a1.34,1.34,0,0,1,0-2.67h62.44a1.34,1.34,0,1,1,0,2.67Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M186.51,245.18a1.34,1.34,0,1,1,0-2.67h74.85a1.34,1.34,0,0,1,0,2.67Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M90.28,227.66a1.34,1.34,0,0,1,0-2.67H196.56a1.34,1.34,0,1,1,0,2.67Zm136.61,0a1.34,1.34,0,0,1,0-2.67h34.47a1.34,1.34,0,0,1,0,2.67Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M91.85,302.74h102a5,5,0,0,1,5,5v31.63a5,5,0,0,1-5,5h-102a5,5,0,0,1-5-5V307.71A5,5,0,0,1,91.85,302.74Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M208.52,302.74h54.42a2.65,2.65,0,0,1,2.65,2.65v16.87a2.65,2.65,0,0,1-2.65,2.65H208.52a2.65,2.65,0,0,1-2.65-2.65V305.39A2.65,2.65,0,0,1,208.52,302.74Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M95.89,312.22a1.34,1.34,0,0,1,0-2.68h56a1.34,1.34,0,0,1,0,2.68Zm75.74,0a1.34,1.34,0,0,1,0-2.68h18.22a1.34,1.34,0,0,1,0,2.68Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M95.89,321a1.34,1.34,0,0,1,0-2.67h94a1.34,1.34,0,0,1,0,2.67Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M95.89,329.81a1.34,1.34,0,0,1,0-2.67h30.25a1.34,1.34,0,0,1,0,2.67Zm49.45,0a1.34,1.34,0,0,1,0-2.67h44.51a1.34,1.34,0,0,1,0,2.67Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M95.89,338.61a1.34,1.34,0,0,1,0-2.67h68.77a1.34,1.34,0,1,1,0,2.67Zm75,0a1.34,1.34,0,0,1,0-2.67h18.93a1.34,1.34,0,0,1,0,2.67Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M207.2,333.23h57.07a1.32,1.32,0,0,1,1.32,1.32V343a1.33,1.33,0,0,1-1.33,1.33H207.2a1.32,1.32,0,0,1-1.32-1.32v-8.44A1.33,1.33,0,0,1,207.2,333.23Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M90.28,211.65a1.34,1.34,0,0,1,0-2.67H261.36a1.34,1.34,0,0,1,0,2.67Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M293.64,184.38l-.41,20.24-7.39,21.08c-9.18-2.74-15.07-10.26-14.58-21.07C271.92,192.89,280.66,183.41,293.64,184.38Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M308.39,222.18a21.26,21.26,0,0,1-19.85,4.3c1.89-6.62,6-20,6-20Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M296.05,184.22a21,21,0,0,1,21,20.88,20.72,20.72,0,0,1-6.53,15.1l-14.44-15.1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M286,246.1a.51.51,0,0,1,0-1h21.64a.51.51,0,1,1,0,1Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M286,248.05a.51.51,0,0,1,0-1h21.64a.51.51,0,1,1,0,1Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M286,250a.51.51,0,0,1,0-1h21.64a.51.51,0,1,1,0,1Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M286,252a.51.51,0,0,1,0-1h21.64a.51.51,0,1,1,0,1Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M286,253.9a.51.51,0,0,1,0-1h21.64a.51.51,0,1,1,0,1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M234.54,64.85a17.21,17.21,0,1,1-17.33,17.2A17.27,17.27,0,0,1,234.54,64.85Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.3,
    cy: 408.59,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 11,
    ry: 10.92
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M274.41,396.76a6.27,6.27,0,1,1-6.32,6.27A6.29,6.29,0,0,1,274.41,396.76Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M282.49,81.05a10.3,10.3,0,1,1-10.37,10.3A10.34,10.34,0,0,1,282.49,81.05Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M141.86,100.68A16.75,16.75,0,1,1,125,117.43,16.81,16.81,0,0,1,141.86,100.68Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M189,169.46a7.37,7.37,0,1,1-7.4,7.36A7.37,7.37,0,0,1,189,169.46Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M217,169.46a7.37,7.37,0,1,1-7.41,7.36A7.37,7.37,0,0,1,217,169.46Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M245,169.46a7.37,7.37,0,1,1-7.41,7.36A7.38,7.38,0,0,1,245,169.46Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M94.26,164.69h78.6a1.18,1.18,0,0,1,1.18,1.18v7.48a1.18,1.18,0,0,1-1.18,1.18H94.26a1.17,1.17,0,0,1-1.17-1.17v-7.48A1.18,1.18,0,0,1,94.26,164.69Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M94.26,181h78.6a1.17,1.17,0,0,1,1.17,1.17v7.48a1.18,1.18,0,0,1-1.18,1.18H94.26a1.17,1.17,0,0,1-1.17-1.17v-7.48A1.18,1.18,0,0,1,94.26,181Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.7992b5ccfa700082f491112c9bc1230f.svg";
export { ForwardRef as ReactComponent };